export const SVGSearch = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 2C12.0899 2 15 4.91015 15 8.5C15 9.89763 14.5589 11.1922 13.8083 12.2522L16.6038 15.0477C17.0453 15.4892 17.0353 16.215 16.5815 16.6689C16.1276 17.1227 15.4018 17.1327 14.9603 16.6912L12.149 13.8799C11.1087 14.5869 9.85259 15 8.5 15C4.91015 15 2 12.0899 2 8.5C2 4.91015 4.91015 2 8.5 2ZM8.5 4C6.01472 4 4 6.01472 4 8.5C4 10.9853 6.01472 13 8.5 13C10.9853 13 13 10.9853 13 8.5C13 6.01472 10.9853 4 8.5 4Z"
        fill="white"
      />
    </svg>
  );
};
